# Generated by https://pagedraw.io/pages/5249
React = require 'react'
createReactClass = require 'create-react-class'
Demobutton = require './demobutton'


module.exports = Playground = createReactClass {
    displayName: 'Playground'
    render: ->
        React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "flexGrow": "1", "paddingTop": 52, "background": "#FFFFFF"})},
          React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
              
              
              * {
                  box-sizing: border-box;
              }
              
              body {
                  margin: 0;
              }
              
              button:hover {
                  cursor: pointer;
              }
              
              a {
                  text-decoration: none;
                  color: inherit;
              }
              
              .pd-onhover-parent >.pd-onhover {
                  display: none;
              }
              
              .pd-onhover-parent:hover > * {
                  display: none;
              }
              
              .pd-onhover-parent:hover > .pd-onhover {
                  display: flex;
              }
              
              .pd-onactive-parent > .pd-onactive {
                  display: none;
              }
              
              .pd-onactive-parent:active > * {
                  display: none;
              }
              
              .pd-onactive-parent:active > .pd-onactive {
                  display: flex;
              }
              
              .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                  display: none;
              }
          """)}),  
          React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0"})},
              React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "flexGrow": "0.5", "flexBasis": 0, "minHeight": "fit-content", "background": "rgba(216, 216, 216, 0)"})},
                  React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0"})},
                      React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.4984709480122324", "flexBasis": 0})}),  
                      React.createElement("div", {"style": ({"flexShrink": "0", "display": "flex", "flexDirection": "column", "minWidth": 172})},
                          React.createElement(Demobutton, {"selected": (true), "content": ("PAGEDRAW EDITOR")}) 
                      ),
                      React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.5015290519877675", "flexBasis": 0})}) 
                  )
              ),
              React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "flexGrow": "0.5", "flexBasis": 0, "minHeight": "fit-content", "marginLeft": 2, "background": "rgba(216, 216, 216, 0)"})},
                  React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0"})},
                      React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.4984709480122324", "flexBasis": 0})}),  
                      React.createElement("div", {"style": ({"flexShrink": "0", "display": "flex", "flexDirection": "column", "minWidth": 172})},
                          React.createElement(Demobutton, {"selected": (true), "content": ("YOUR INTEGRATION")}) 
                      ),
                      React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.5015290519877675", "flexBasis": 0})}) 
                  )
              )
          ),
          React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "marginTop": 7})},
              React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "flexGrow": "0.5", "flexBasis": 0, "minHeight": "fit-content", "paddingBottom": 1})},
                  React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0"})},
                      React.createElement("div", {"style": ({"height": 330, "flexGrow": "1", "flexBasis": 0, "display": "flex", "flexDirection": "column"})},
                          (@props.pdEditor)
                      )
                  )
              ),
              React.createElement("div", {"style": ({"height": 331, "flexGrow": "0.5", "flexBasis": 0, "overflow": "scroll", "position": "relative", "background": "rgba(216, 216, 216, 0)"})},
                  React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "flexGrow": "1", "position": "absolute", "width": "100%", "minHeight": "100%"})},
                      React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0"})},
                          React.createElement("div", {"style": ({"height": 330, "flexGrow": "1", "flexBasis": 0, "display": "flex", "flexDirection": "column"})},
                              (@props.codeEditor)
                          )
                      ),
                      React.createElement("div", {"style": ({"width": 0, "flexShrink": "0", "flexGrow": "1", "flexBasis": 0})}) 
                  )
              )
          ),
          React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "marginTop": 29, "paddingLeft": 276, "paddingRight": 278})},
              React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "flexGrow": "1", "flexBasis": 0, "minHeight": "fit-content", "background": "rgba(216, 216, 216, 0)"})},
                  React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "justifyContent": "center"})},
                      React.createElement("div", {"style": ({"flexShrink": "0", "display": "flex", "flexDirection": "column", "minWidth": 172})},
                          React.createElement(Demobutton, {"selected": (true), "content": ("LIVE APP")}) 
                      )
                  )
              )
          ),
          React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "marginTop": 19})},
              React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.4981949458483754", "flexBasis": 0})}),  
              React.createElement("div", {"style": ({"width": 446, "height": 333, "flexShrink": "0", "display": "flex", "flexDirection": "column"})},
                  (@props.preview)
              ),
              React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.5018050541516246", "flexBasis": 0})}) 
          )
      )
}



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/playground.cjsx